export default {
  header: "See all the pizzas",
  view: "Pizza",
  pizzas: []
};
